/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Bell, BellRing } from 'lucide-react';
import { NotificationsProvider } from '../context/NotificationsContext';
import NotificationsPreferences from '../components/notifications/NotificationsPreferences';
import PushNotificationToggle from '../components/notifications/PushNotificationToggle';
import PageBackButton from '../components/PageBackButton';

function NotificationSettingsContent() {
  return (
    <div className="p-3 sm:p-4 md:p-6 lg:p-8 max-w-3xl">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <PageBackButton label="Back to Settings" to="/settings" preferHistory={false} hideLabelOnMobile />
        <Bell className="w-6 h-6 text-primary" />
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-textPrimary">
          Notification Settings
        </h1>
      </div>

      {/* Push Notifications */}
      <div className="bg-backgroundSurface p-4 sm:p-6 rounded-lg shadow mb-6">
        <div className="flex items-center gap-2 mb-4">
          <BellRing className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold text-textPrimary">Push Notifications</h2>
        </div>
        <p className="text-sm text-textSecondary mb-4">
          Receive notifications even when the app is in the background or closed.
          Your browser will ask for permission when you enable this.
        </p>
        <PushNotificationToggle />
      </div>

      {/* Per-category preferences */}
      <div className="bg-backgroundSurface p-4 sm:p-6 rounded-lg shadow">
        <div className="flex items-center gap-2 mb-4">
          <Bell className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold text-textPrimary">Category Preferences</h2>
        </div>
        <p className="text-sm text-textSecondary mb-4">
          Control which notification categories you receive and their minimum severity level.
        </p>
        <NotificationsPreferences />
      </div>
    </div>
  );
}

export default function NotificationSettingsPage() {
  return (
    <NotificationsProvider>
      <NotificationSettingsContent />
    </NotificationsProvider>
  );
}
